<template>
    <v-container fluid>
        <v-card>
            <v-form ref="billingItemForm" v-model="isValid">
                <v-card-text>
                    <v-container class="pb-0" fluid>
                        <v-row v-if="billingItem.id > 0" class="pb-0">
                            <v-col cols="12"></v-col>
                            <!--<v-col
                                cols="12"
                                class="my-0 py-0 text-subtitle-1 font-weight-black"
                                >Is Final Account</v-col
                            >
                            <v-col cols="12" class="my-0 py-0">{{
                                billingItem.isFinal ? "Yes" : "No"
                            }}</v-col>-->
                            <v-col
                                cols="12"
                                class="my-0 py-0 text-subtitle-1 font-weight-black"
                                >Invoice Number</v-col
                            >
                            <v-col cols="12" class="my-0 py-0">{{
                                billingItem.invoiceNumber
                            }}</v-col>

                            <v-col cols="6">
                                <v-row>
                                    <v-col cols="12"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Invoice Status</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        getMedediStatusName(
                                            billingItem.medediStatus
                                        )
                                    }}</v-col>
                                </v-row>
                            </v-col>
                            <!--
                            <v-col cols="6"
                            >
                                <v-row>
                                    <v-col cols="12"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Place of Service</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        getMedediPlaceOfServiceName(
                                            billingItem.placeOfService
                                        )
                                    }}</v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="6"
                            >
                                <v-row v-show="billingItem.dateOfService">
                                    <v-col cols="12"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Date of Service</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{dateToString(new Date(billingItemIn.dateOfService))}}</v-col>
                                </v-row>
                            </v-col>
-->
                            <v-col cols="6">
                                <v-row v-show="billingItem.hasReferringDr">
                                    <v-col cols="12"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Referring Doctor</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        billingItem.referringDrName
                                    }}</v-col>
                                    <v-col cols="12" class="my-0 py-0"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Referring Dr. Practice Number</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        billingItem.referringDrPracticeNum
                                    }}</v-col>
                                </v-row>
                            </v-col>

                            <!--<v-col v-show="billingItem.accountId > 0" cols="6">
                                <v-row>
                                    <v-col cols="12"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Billing Account</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        "#" + billingItem.accountId
                                    }}</v-col>
                                </v-row>
                            </v-col>-->
                            <v-col cols="12">
                                <v-btn
                                    v-show="billingItem.medediStatus == null"
                                    :disabled="isLoading"
                                    :loading="gettingLink"
                                    @click="getLink"
                                    color="secondary"
                                    >Capture Invoice</v-btn
                                >
                            </v-col>

                            <v-col
                                cols="12"
                                v-show="
                                    !anesthesia &&
                                        (!firstReportSaved ||
                                            billingItem.iaIsSaved)
                                "
                            >
                                <v-btn
                                    :disabled="isLoading"
                                    :loading="gettingLink"
                                    @click="
                                        billingItemInitialAssessmentFormShow = true
                                    "
                                    color="blue-grey white--text"
                                    >Capture Initial Assessment
                                    {{
                                        billingItem.iaIsSaved ? "✓" : ""
                                    }}</v-btn
                                >
                            </v-col>

                            <v-col
                                cols="12"
                                v-show="
                                    anesthesia /*&&
                                        (!firstReportSaved ||
                                            billingItem.arIsSaved)*/
                                "
                            >
                                <v-btn
                                    :disabled="isLoading"
                                    :loading="gettingLink"
                                    @click="
                                        billingItemAnesthesiaReportFormShow = true
                                    "
                                    color="secondary"
                                    >Capture Anaesthesia Report
                                    {{
                                        billingItem.arIsSaved ? "✓" : ""
                                    }}</v-btn
                                >
                            </v-col>

                            <v-col cols="12">
                                <v-btn
                                    v-show="firstReportSaved || billingItem.prIsSaved"
                                    :disabled="isLoading"
                                    :loading="gettingLink"
                                    @click="
                                        billingItemProgressReportFormFormShow = true
                                    "
                                    color="primary"
                                    >Capture Progress Report
                                    {{
                                        billingItem.prIsSaved ? "✓" : ""
                                    }}</v-btn
                                >
                            </v-col>

                            <!--<v-col cols="12">
                                <v-btn
                                    v-show="
                                        billingItem.linkUrl &&
                                        billingItem.medediStatus != 2
                                    "
                                    :disabled="isLoading"
                                    :loading="checkingInvoiceStatus"
                                    @click="checkInvoiceStatus"
                                    color="secondary"
                                    >Check Invoice status</v-btn
                                >
                            </v-col>-->

                            <!--<v-col cols="12">
                                <v-btn
                                    v-show="
                                        billingItem.linkUrl &&
                                        billingItem.medediStatus == 2 &&
                                        billingItem.invoiceFileId > 0
                                    "
                                    :disabled="isLoading"
                                    @click="
                                        getFile(
                                            billingItem.invoiceFileId,
                                            'Billing' + billingItem.id + '_'
                                        )
                                    "
                                    color="secondary"
                                    >Get Invoice</v-btn
                                >
                            </v-col>-->

                            <!--<v-col cols="12">
                                <v-btn
                                    v-show="
                                        billingItem.linkUrl &&
                                        billingItem.medediStatus == 2 &&
                                        billingItem.invoiceFileId > 0 &&
                                        !(billingItem.accountId > 0) &&
                                        billingItem.localBillingStatus == 0
                                    "
                                    :disabled="isLoading"
                                    :loading="convertingToAccount"
                                    @click="convertToAccount"
                                    color="secondary"
                                    >Convert to Account</v-btn
                                >
                            </v-col>-->
                        </v-row>
                        <v-row v-else class="pb-0">
                            <!--<v-col cols="12">
                                <v-text-field
                                    :disabled="isLoading"
                                    :rules="[
                                        //requiredRule,
                                        lengthRule(50),
                                    ]"
                                    label="Invoice Number"
                                    v-model="billingItem.invoiceNumber"
                                ></v-text-field>
                            </v-col>-->
                            <!--<v-col cols="12">
                                <v-switch
                                    :disabled="isLoading"
                                    class="mb-0"
                                    label="Is Final"
                                    v-model="billingItem.isFinal"
                                ></v-switch>
                            </v-col>-->
                            <!--
                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading"
                                    :items="medediPlacesOfService"
                                    item-text="value"
                                    item-value="key"
                                    label="Place of Service"
                                    v-model="billingItem.placeOfService"
                                ></v-select>
                            </v-col>
                                                                <v-col cols="12">
                                                                        <v-menu
                                                                            :close-on-content-click="false"
                                                                            :nudge-right="40"
                                                                            min-width="290px"
                                                                            offset-y
                                                                            transition="scale-transition"
                                                                            v-model="showDateOfService"
                                                                        >
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-text-field
                                                                                    :disabled="isLoading"
                                                                                    clearable
                                                                                    :rules="[requiredRule]"
                                                                                    label="Date of Service"
                                                                                    prepend-icon="mdi-calendar-month"
                                                                                    readonly
                                                                                    v-bind="attrs"
                                                                                    v-model="billingItem.dateOfService"
                                                                                    v-on="on"
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <v-date-picker
                                                                                :disabled="isLoading"
                                                                                @input="showDateOfService = false"
                                                                                v-model="billingItem.dateOfService"
                                                                            ></v-date-picker>
                                                                        </v-menu>
                                                                    </v-col>
                                                                    -->
                            <v-col cols="12">
                                <v-switch
                                    :disabled="isLoading"
                                    class="mb-0 strong"
                                    label="Referring Doctor"
                                    v-model="billingItem.hasReferringDr"
                                ></v-switch>
                                <v-expand-transition>
                                    <v-row
                                        no-gutters
                                        v-show="billingItem.hasReferringDr"
                                    >
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[
                                                    !billingItem.hasReferringDr ||
                                                        requiredRule,
                                                ]"
                                                label="Doctor"
                                                v-model="
                                                    billingItem.referringDrName
                                                "
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[
                                                    !billingItem.hasReferringDr ||
                                                        requiredRule,
                                                ]"
                                                label="Practice Number"
                                                v-model="
                                                    billingItem.referringDrPracticeNum
                                                "
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-file-input
                                                :disabled="isLoading"
                                                :rules="[
                                                    !billingItem.hasReferringDr ||
                                                        requiredRule,
                                                ]"
                                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                                label="Referral letter"
                                                v-model="referralLetter"
                                            >
                                            </v-file-input>
                                        </v-col>
                                    </v-row>
                                </v-expand-transition>
                            </v-col>
                        </v-row>
                        <!--<v-row class="pb-0" v-show="billingItem.id > 0">
                            <v-col cols="12">
                                <v-select
                                    :disabled="isLoading || billingItem.accountId > 0"
                                    :items="localBillingStatuses"
                                    item-text="value"
                                    item-value="key"
                                    label="Accicare Status"
                                    v-model="billingItem.localBillingStatus"
                                ></v-select>
                            </v-col>
                        </v-row>-->
                        <v-row class="pb-0">
                            <v-col cols="12">
                                <v-select
                                    :disabled="
                                        isLoading || !!billingItem.linkUrl
                                    "
                                    :items="medediPlacesOfService"
                                    item-text="value"
                                    item-value="key"
                                    label="Place of Service"
                                    v-model="billingItem.placeOfService"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :disabled="
                                        isLoading || !!billingItem.linkUrl
                                    "
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"
                                    v-model="showDateOfService"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :disabled="
                                                isLoading ||
                                                    !!billingItem.linkUrl
                                            "
                                            clearable
                                            :rules="[requiredRule]"
                                            label="Date of Service"
                                            prepend-icon="mdi-calendar-month"
                                            readonly
                                            v-bind="attrs"
                                            v-model="inputDateOfService"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        :disabled="
                                            isLoading || !!billingItem.linkUrl
                                        "
                                        @input="showDateOfService = false"
                                        v-model="inputDateOfService"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row
                            align="end"
                            class="pt-0"
                            justify="space-between"
                            no-gutters
                        >
                            <v-btn
                                :disabled="isLoading"
                                @click="closeModalForm"
                                class="text-none"
                                color="warning darken-1"
                                text
                                v-show="isModal"
                                >Close</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                :disabled="isLoading && !isDeleting"
                                :loading="isDeleting"
                                @click="deleteEntity"
                                class="text-none"
                                color="warning darken-1"
                                text
                                v-show="billingItem.id > 0 && !hasFinalInvoice"
                                >Delete</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                v-show="!billingItem.linkUrl"
                                :disabled="isLoading || !!billingItem.linkUrl"
                                :loading="isSaving"
                                @click="saveEntity"
                                class="text-none"
                                color="secondary darken-1"
                                text
                                >{{
                                    billingItem.id > 0 ? "Update" : "Add"
                                }}</v-btn
                            >
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-form>
        </v-card>
        <v-dialog
            persistent
            v-model="billingItemInitialAssessmentFormShow"
            width="800px"
        >
            <BillingItemInitialAssessmentForm
                :billing-item-in="billingItem"
                :key="billingItem.id"
                :is-modal="true"
                :can-save="!hasFinalInvoice"
                @close="billingItemInitialAssessmentFormShow = false"
                @loadBilling="reload"
                @notify="notify"
                @reload="reload"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="billingItemProgressReportFormFormShow"
            width="800px"
        >
            <BillingItemProgressReportForm
                :billing-item-in="billingItem"
                :key="billingItem.id"
                :is-modal="true"
                :can-save="!hasFinalInvoice"
                @close="billingItemProgressReportFormFormShow = false"
                @loadBilling="reload"
                @notify="notify"
                @reload="reload"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="billingItemAnesthesiaReportFormShow"
            width="800px"
        >
            <BillingItemAnesthesiaReportForm
                :billing-item-in="billingItem"
                :key="billingItem.id"
                :is-modal="true"
                :can-save="!hasFinalInvoice"
                @close="billingItemAnesthesiaReportFormShow = false"
                @loadBilling="reload"
                @notify="notify"
                @reload="reload"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import BillingItem from "../../models/BillingItem.model";
import dateToString from "../../helpers/dateToString";
import BillingItemInitialAssessmentForm from "../forms/BillingItemInitialAssessmentForm";
import BillingItemProgressReportForm from "../forms/BillingItemProgressReportForm";
import BillingItemAnesthesiaReportForm from "../forms/BillingItemAnesthesiaReportForm";
export default {
    props: {
        billingItemIn: Object,
        isModal: Boolean,
        hasFinalInvoice: Boolean,
        firstReportSaved: Boolean,
        anesthesia: Boolean,
    },
    components: {
        BillingItemInitialAssessmentForm,
        BillingItemProgressReportForm,
        BillingItemAnesthesiaReportForm,
        //
    },
    created: async function() {
        //
        this.medediStatuses = await this.$store.dispatch(
            "billingitems/getMedediStatuses"
        );
        this.localBillingStatuses = await this.$store.dispatch(
            "billingitems/getLocalStatuses"
        );
        this.medediPlacesOfService = await this.$store.dispatch(
            "billingitems/getMedediPlacesOfService"
        );
    },
    mounted: async function() {
        //
        this.loadBillingItem();
    },
    data() {
        return {
            canSaveReport: true,
            billingItemInitialAssessmentFormShow: false,
            billingItemProgressReportFormFormShow: false,
            billingItemAnesthesiaReportFormShow: false,
            billingItem: {},
            medediStatuses: [],
            localBillingStatuses: [],
            medediPlacesOfService: [],
            showDateOfService: false,
            inputDateOfService: null,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: (v) => /.+@.+$/.test(v) || "invalid email",
            gettingLink: null,
            checkingInvoiceStatus: null,
            convertingToAccount: null,

            captureIABillingItemId: 0,
            isShowCaptureIA: false,
            captureARBillingItemId: 0,
            isShowCaptureAR: false,
            capturePRBillingItemId: 0,
            isShowCapturePR: false,
            referralLetter: null,
        };
    },
    computed: {
        //
    },
    methods: {
        showCaptureIA(billingItemId) {
            this.captureIABillingItemId = billingItemId;
            this.isShowCaptureIA = true;
        },
        showCaptureAR(billingItemId) {
            this.captureARBillingItemId = billingItemId;
            this.isShowCaptureAR = true;
        },
        showCapturePR(billingItemId) {
            this.capturePRBillingItemId = billingItemId;
            this.isShowCapturePR = true;
        },
        dateToString(i) {
            return dateToString(i);
        },
        closeModalForm() {
            this.$emit("close");
        },
        reload() {
            this.$emit("reload");
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix,
            });
        },
        async convertToAccount() {
            this.isLoading = true;
            this.convertingToAccount = true;
            try {
                await this.$store.dispatch(
                    "billingitems/convertToAccount",
                    this.billingItem.id
                );
                this.reload();
            } catch (e) {
                this.notify(e.response.data, "error");
            } finally {
                this.isLoading = false;
                this.convertingToAccount = false;
            }
        },
        async getLink() {
            this.isLoading = true;
            this.gettingLink = true;
            try {
                var response = await this.$store.dispatch(
                    "billingitems/getBillingItemLink",
                    this.billingItem.id
                );
                window.open(response, "_blank");
                this.reload();
            } catch (e) {
                this.notify(e.response.data, "error");
            } finally {
                this.isLoading = false;
                this.gettingLink = false;
            }
        },
        async checkInvoiceStatus() {
            this.isLoading = true;
            this.checkingInvoiceStatus = true;
            try {
                await this.$store.dispatch(
                    "billingitems/checkStatus",
                    this.billingItem.id
                );
                this.reload();
            } catch (e) {
                this.notify(e.response.data, "error");
            } finally {
                this.isLoading = false;
                this.checkingInvoiceStatus = false;
            }
        },

        getMedediStatusName(statusId) {
            var statuses = this.medediStatuses.filter(function(item) {
                return item.key == statusId;
            });
            if (statuses.length > 0) return "Submitted";
            //statuses[0].value;
            else return "Not Submitted"; //"N/A";
        },
        getMedediPlaceOfServiceName(statusId) {
            var statuses = this.medediPlacesOfService.filter(function(item) {
                return item.key == statusId;
            });
            if (statuses.length > 0) return statuses[0].value;
            else return "N/A";
        },

        loadBillingItem() {
            this.billingItem = new BillingItem().set(this.billingItemIn);
            var inputDateTime = this.billingItem.dateOfService
                ? new Date(this.billingItem.dateOfService)
                : new Date();
            this.inputDateOfService = dateToString(inputDateTime);
        },
        //emitters      ------------------------------------------------------------
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.$emit("notify", message, color);
        },
        validateForm() {
            this.isValid = this.$refs.billingItemForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                var hasId = this.billingItem.id > 0;
                this.billingItem.dateOfService =
                    this.inputDateOfService + "T00:00:00";

                var formdata = new FormData();
                formdata.append("ReferralLetter", this.referralLetter);
                formdata.append("Model", JSON.stringify(this.billingItem));

                const parameters = {
                    id: this.billingItem.id,
                    formData: formdata,
                };

                try {
                    //var billingResponse =
                    await this.$store.dispatch(
                        "billingitems/" + (hasId ? "update" : "create"),
                        !hasId ? parameters.formData : parameters
                    );
                    this.notify("Billing item successfully saved.", "success");
                    this.reload();
                    if (!hasId) this.closeModalForm();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingWelcome = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this billing item?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("billingitems/delete", this.billingItem.id)
                    .then(
                        () => {
                            this.notify(
                                "Billing item successfully deleted.",
                                "success"
                            );
                            this.reload();
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>
